import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import * as routes from '../../../constants/routes';

import firebase from '../../../firebase';
import { history } from "../../../history";

import '../../Quiz/QuizDetails/Form/Form.css';

class SignInForm extends Component {

    state = {
        email: '',
        password: '',
        errorEmail: false,
        errorPassword: false,
        errorSignIn: false,
        errorSignInType: '',
        loadingActive: false,
        isBtnActive: false
    };

    componentDidMount = () => {
        this.emailInput.focus();
    };

    formIsValid = () => {
        return (!!this.state.email && !!this.state.password);
    };

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });

        if (e.target.name === 'email') {
            this.setState({errorEmail: !this.state.email});
        }

        if (e.target.name === 'password') {
            this.setState({errorPassword: !this.state.password});
        }

        setTimeout(() => {
            if (this.formIsValid()) {
                this.setState({isBtnActive: true});
            } else {
                this.setState({isBtnActive: false});
            }
        }, 200);
    };

    handleSubmit = (e) => {
        e.preventDefault();

        this.setState({loadingActive: true});

        // firebase auth
        const {
            email,
            password,
        } = this.state;

        firebase.auth().signInWithEmailAndPassword(email, password)
            .then(() => {
                this.setState({
                    loadingActive: false,
                    errorSignInType: ''
                });
                history.push(routes.REPORT);
            })
            .catch(error => {
                this.setState({loadingActive: false, errorSignIn: true});

                //console.log(error);

                if(typeof error.code !== "undefined"){
                    if(error.code === "auth/wrong-password"){
                        this.setState({
                            errorSignIn: true,
                            errorSignInType: 'auth/wrong-password'
                        });
                    }
                    if(error.code === "auth/user-not-found"){
                        this.setState({
                            errorSignIn: true,
                            errorSignInType: 'auth/user-not-found'
                        });
                    }
                }
            });
    };

    render() {

        const {email, password, errorEmail, errorPassword, errorSignIn, errorSignInType, loadingActive, isBtnActive} = this.state;

        return (
            <div className="form">
                <h1 className="form__title">Sign In</h1>
                <p className="form__desc">Enter your email and password below to access your report.</p>
                <form method="post" action="" className="form__wrapper">
                    <div className="form__input-area">
                        <label htmlFor="name" className="form__label">Email</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            className={'form__input' + (errorEmail ? ' input-error' : '')}
                            placeholder="e.g. email@ema.com"
                            ref={(email) => { this.emailInput = email; }}
                            value={email}
                            onChange={this.handleChange}
                            onBlur={this.handleChange}
                        />
                    </div>
                    <div className="form__input-area">
                        <label htmlFor="password" className="form__label">Password</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            className={'form__input' + (errorPassword ? ' input-error' : '')}
                            placeholder="your password"
                            value={password}
                            onChange={this.handleChange}
                            onBlur={this.handleChange}
                        />
                    </div>

                    {errorSignIn &&
                        <div className="clear">
                            {errorSignInType === 'auth/wrong-password' &&
                                <p className="error__message">* Wrong password provided!</p>
                            }

                            {errorSignInType === 'auth/user-not-found' &&
                                <p className="error__message">* Email address not registered!</p>
                            }
                        </div>
                    }

                    <button
                        type="submit"
                        className={`button button_send-form ` + (loadingActive ? 'loading__btn' : '')}
                        onClick={this.handleSubmit}
                        disabled={!isBtnActive}
                    >Sign In</button>

                </form>
                <p className="form__additional">
                    Forgot password? <Link to={routes.FORGOT_PASSWORD}>Reset now</Link>
                </p>
                <p className="form__additional">
                    Don't have an account? <Link to={routes.LANDING}>Sign up now</Link>
                </p>
            </div>
        )
    }

}

export default SignInForm;


// WEBPACK FOOTER //
// ./src/components/Auth/SignIn/SignInForm.js